/* eslint no-console: "off" */
import BaseIntegration from '@/common/mixins/integrations/baseIntegration';
import TpayIntegration from '@/common/mixins/integrations/tpayIntegration';
import DuEtisalatIntegration from '@/common/mixins/integrations/duEtisalatIntegration';
import MyanmarIntegration from '@/common/mixins/integrations/myanmarIntegration';
import IraqZainIntegration from '@/common/mixins/integrations/iraqZainIntegration';
import KuwaitZainIntegration from '@/common/mixins/integrations/kuwaitZainIntegration';
import VivaKuwaitIntegration from '@/common/mixins/integrations/vivaKuwaitIntegration';
import KsaMobilyIntegration from '@/common/mixins/integrations/ksaMobilyIntegration';
import BatelcoBahrainIntegration from '@/common/mixins/integrations/batelcoBahrainIntegration';
import MtnRsaIntegration from '@/common/mixins/integrations/mtnrsaIntegration';
import SyriatelSyriaIntegration from '@/common/mixins/integrations/syriatelSyriaIntegration';
import MondiaPayDenmarkIntegration from '@/common/mixins/integrations/mondiaPayDenmarkIntegration';
import OoredooAlgeriaIntegration from '@/common/mixins/integrations/ooredooAlgeriaIntegration';
import OmanOmantelIntegration from '@/common/mixins/integrations/omanOmantelIntegration';
import Integration from '@/common/mixins/integrations/integrationControll';
import Vue from 'vue';
import axios from 'axios';
import VueGtm from 'vue-gtm';
import ProgressBar from 'progressbar.js';
import IdleVue from 'idle-vue';
import App from './App';
import router from './router';
import store from './store';
import auth from './common/auth';

const eventsHub = new Vue();

Vue.use(ProgressBar);

Vue.use(VueGtm, {
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 30000, // 30 seconds,
  startAtIdle: false,
});

Vue.config.devtools = false;
Vue.config.productionTip = false;
Object.defineProperty(Vue.prototype, '$axios', { value: axios });

axios.interceptors.request.use((config) => {
  // eslint-disable-next-line
  config.url = `${window.location.origin}/${config.url}`;
  return config;
}, (error) => { Promise.reject(error); });

if (sessionStorage.getItem('splashScreenProgrammaticallyRefresh') !== true) {
  sessionStorage.setItem('splashScreenAlreadyDisplayed', 'false');
}

function applyStyleClasses(to) {
  if (to.matched.some(record => record.meta.hasHomeClass)) {
    document.body.classList.add('home_v2');
  } else {
    document.body.classList.remove('home_v2');
  }
}

// eslint-disable-next-line
function extractParametersFromUrl({ fb_ref, lang, inviteReferral, refUrl, clickid, campaignId, publisherId, banner, cpc, affiliate_name }, next) {
  // eslint-disable-next-line
  store.commit({ type: 'common/facebookReferral', fbRef: fb_ref || '' });
  store.commit({ type: 'common/storeBanner', value: banner || '' });

  if (['ar', 'AR', 'en', 'EN'].indexOf(lang) !== -1) {
    store.dispatch({ type: 'i18n/methodTochangeLocales', currentLocale: lang });
  }

  if (!localStorage.getItem('locale')) {
    const currentLocale = store.getters['i18n/getDefaultLanguage'];
    store.dispatch({ type: 'i18n/methodTochangeLocales', currentLocale });
  }

  if (!store.getters['common/getInviteReferral']) {
    store.commit({ type: 'common/storeInviteReferral', inviteReferral });
  }

  if (!store.getters['common/getClickId']) {
    store.commit({ type: 'common/storeClickid', clickid });
  }

  if (!store.getters['common/getCampaignId']) {
    store.commit({ type: 'common/updateCampaignId', campaignId });
  }

  if (!store.getters['common/getPublisherId']) {
    store.commit({ type: 'common/updatePublisherId', publisherId });
  }

  if (!store.getters['common/getRefUrl']) {
    store.commit({ type: 'common/updateRefUrl', refUrl });
    // check if refUrl is Blocked from DB and make a call only if refUrl exists
    if (refUrl) { // check if refUrl is undefined or empty
      const dataAdv = {
        refUrl,
        publisherId,
      };
      store.dispatch({ type: 'common/checkIfURLisBlocked', value: dataAdv }).then((response) => {
        console.log('response.data.responseEnum');
        console.log(response.data.responseEnum);
        if (response.data.responseEnum === 'SERVER_ERROR' || response.data.responseEnum === 'BLOCKED_USER') {
          console.log('Go to an errorpage EXC-2474');
          store.commit({ type: 'common/updateRefUrl' });
          next({ path: '/error' });
        } else {
          // eslint-disable-next-line
          if (!store.getters['common/getCPC'] && cpc && refUrl) {
            store.commit({ type: 'common/updateCPC', cpc });
            const dataAdve = {
              refUrl,
              publisherId,
              cpc,
              clickid,
            };
            store.dispatch({ type: 'common/saveCPC', value: dataAdve }).then(() => {
              console.log('CPC updated in BI_CPC_VARIATIONS');
            });
          }
        }
      });
    } else {
      store.commit({ type: 'common/updateRefUrl', refUrl: affiliate_name }); // EXC-4232 - affise integration
    }
  }
}

router.beforeEach((to, from, next) => {
  console.log('==> in global before each:');
  if (to.query.checkId && to.query.email) {
    const payload = {
      checkId: to.query.checkId,
      email: decodeURIComponent(to.query.email),
    };
    store.commit({ type: 'common/emailVerification', payload });
  }
  sessionStorage.setItem('toPage', to.fullPath);
  applyStyleClasses(to);
  extractParametersFromUrl(to.query, next);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (auth.checkAuth()) {
      if (to.path === '/searchingOpponent') {
        console.log('User Tries to navigate to searchingOpponent');
        store.dispatch({ type: 'common/proceedWithSearchingOpponent' }).then(() => {
          if ((store.state.common.userDetails.availableGames === 0) || (store.state.game.gameInProgress) || (store.state.game.gamePending)) {
            console.log('User cannot navigate searchingOpponent page');
            next({ path: '/home' });
          } else {
            next();
          }
        });
      } else {
        // if a game page was refreshed redirect to home page
        console.log(`User ${store.state.common.userDetails.username} has valid jwt Token and want to go from free to logged or refresh page`);
        if (!store.state.common.userDetails.username) {
          console.log('getUserLoginDetails has triggered');
          store.dispatch({ type: 'profile/getUserLoginDetails' }).then(() => {
            console.log(`User is ${store.state.profile.userAuthorized} to proceed`);
            next();
          });
        } else {
          next();
        }
      }
    } else {
      next({ path: '/login' });
    }
  } else {
    // eslint-disable-next-line
    if (auth.checkAuth()) {
      console.log('JWT enabled and user wants to go to free pages and needs the userDetails from Duel db');
      next({ path: '/home' });
    } else {
      console.log('not, REQUIRES AUTH');
      next(); // make sure to always call next()!
    }
  }
});

store.dispatch('common/getRequiredServerData')
  .then(() => {
    /* eslint-disable no-new */

    const { integrationKey } = store.getters['common/getIntegrationConfig'];
    const availableIntegrations = store.getters['common/getAvailableIntegrations'];

    const getActiveIntegration = () => {
      switch (integrationKey) {
      case availableIntegrations.TPAY_EGYPT: return TpayIntegration;
      case availableIntegrations.DU_ETISALAT: return DuEtisalatIntegration;
      case availableIntegrations.MYANMAR: return MyanmarIntegration;
      case availableIntegrations.IRAQ_ZAIN: return IraqZainIntegration;
      case availableIntegrations.VIVA_KUWAIT: return VivaKuwaitIntegration;
      case availableIntegrations.KUWAIT_ZAIN: return KuwaitZainIntegration;
      case availableIntegrations.KSA_MOBILY: return KsaMobilyIntegration;
      case availableIntegrations.BATELCO_BAHRAIN: return BatelcoBahrainIntegration;
      case availableIntegrations.MONDIA_PAY_DENMARK: return MondiaPayDenmarkIntegration;
      case availableIntegrations.MTN_RSA: return MtnRsaIntegration;
      case availableIntegrations.SYRIATEL_SYRIA: return SyriatelSyriaIntegration;
      case availableIntegrations.OOREDOO_ALGERIA: return OoredooAlgeriaIntegration;
      case availableIntegrations.OMANTEL_OMAN.name: return OmanOmantelIntegration;
      default: return BaseIntegration;
      }
    };

    const mixin = { ...Integration };

    mixin.mixins = [...mixin.mixins, getActiveIntegration()];

    Vue.mixin(mixin);

    new Vue({
      el: '#app',
      router,
      auth,
      store,
      template: '<App/>',
      components: { App },
    });
  });



// WEBPACK FOOTER //
// ./src/main.js